import React from "react";
import PageWrapper from "../../components/PageWrapper";
import { IPortalRouteOptions } from "../../shared/types/shared/routes/routeTypes";
import {  NotificationsActive } from "@mui/icons-material";
import { Grid } from "@mui/material";
import { EmailAlertTable } from "../../components/dispatch/alertManagement/EmailAlertTable";
import { useGetDispatchAlertSubscribersQuery, useAddDispatchAlertSubscriberMutation, useRemoveDispatchAlertSubscriberMutation } from "../../shared/api/DispatchApi";

const DispatchAlertManagementPage: React.FC<IDispatchAlertManagementPage> = () => {
    const { data, isLoading } = useGetDispatchAlertSubscribersQuery()
    const [addSubscriber] = useAddDispatchAlertSubscriberMutation()
    const [removeSubscriber] = useRemoveDispatchAlertSubscriberMutation()

    const addPNEmail = (email: string) => {
        let subscriber = {
            email: email,
            notificationType: "PN"
        }
        addSubscriber(subscriber)
    }

    const addPerfmonEmail = (email: string) => {
        let subscriber = {
            email: email,
            notificationType: "Perfmon"
        }
        addSubscriber(subscriber)
    }

    const onRemovePNEmail = (email: string) => {
        let subscriber = {
            email: email,
            notificationType: "PN"
        }
        removeSubscriber(subscriber)
    }

    const onRemovePerfmonEmail = (email: string) => {
        let subscriber = {
            email: email,
            notificationType: "Perfmon"
        }
        removeSubscriber(subscriber)
    }

    return (
        <PageWrapper title="Alert Management" loaded={!isLoading}>
            {
                data &&
                <Grid container spacing={2}>
                    <Grid xs={6} p={2}>
                        <EmailAlertTable title={"PN"} emails={data.pnSubscribers} addEmail={addPNEmail} removeEmail={onRemovePNEmail} />
                    </Grid>
                    <Grid xs={6} p={2}>
                        <EmailAlertTable title={"Perfmon"} emails={data.perfmonSubscribers} addEmail={addPerfmonEmail} removeEmail={onRemovePerfmonEmail} />
                    </Grid>
                </Grid>
            }
        </PageWrapper>
    );
}

export interface IDispatchAlertManagementPage {

}

const DispatchAlertPageConfig: IPortalRouteOptions = {
  relativeUrl: "alertManagement",
    page: <DispatchAlertManagementPage />,
  navDisplay: {
      title: "Alert Management",
      icon: <NotificationsActive />
  }
}

export default DispatchAlertPageConfig;
